<template>
    <Loader v-if="!pageLoaded && !coursesReady" />
    <div v-else-if="pageLoaded" class="main-container" ref="scrollComponent" >
        <!-- <div class="filter-nav">
            <div class="search"><input v-model="inputSearch" @keypress.enter="addSearchFilter" type="text" placeholder="Buscar en Cursos"><i class="material-icons">search</i></div>
        </div> -->
        <div class="filters">
            
            
            <div  class="dropdown dropdown--tutors" ref="filter-tutors"
            v-if="user.permissions.includes('CURSOS_FILTRAR_TUTOR')"
            >
                <input type="checkbox" id="filter-tutors" v-model="isDropdownOpen">
                <div class="dropdown__search" v-show="isDropdownOpen">
                    <input type="text" id="filter-search" placeholder="Buscar facilitadores..." v-model="searchTutor">
                    <i class="material-icons" data-v-46ac34bc=""
                    @click.stop="isDropdownOpen = false; hiddenItems('filter-tutors')"
                    >keyboard_arrow_down</i>
                </div>
                <label class="dropdown__face" for="filter-tutors" v-show="!isDropdownOpen">
                    {{ selectedTutorName }} <i class="material-icons">keyboard_arrow_down</i>
                </label>
                <div class="dropdown__items dropdown--tutors__items" v-show="isDropdownOpen">
                    <ul class="dropdown__items__cont dropdown--tutors__items__cont">
                        <li
                        @click="filters.tutor = ''; selectedTutorName = 'Facilitadores'; selectedTutorId = ''; hiddenItems('filter-tutors'); getCourses(); isDropdownOpen = false;cleanFilterTutors();"
                        >Todos</li>
                        <li v-for="tutor in filteredTutors" :key="tutor"
                        @click="filters.tutor = tutor.id; selectedTutorName = tutor.fullName; hiddenItems('filter-tutors'); getCourses(); hiddenItems('filter-tutors');isDropdownOpen = false; cleanFilterTutors();"
                        >{{ tutor.fullName }}</li>
                    </ul>
                </div>
            </div>

            <div  class="dropdown" ref="filter-status">
                <input type="checkbox" id="filter-status">
                <label class="dropdown__face" for="filter-status">
                    {{ filters.status }} <i class="material-icons">keyboard_arrow_down</i>
                </label>
                <ul class="dropdown__items">
                    <li @click="filters.status = status; hiddenItems('filter-status')" v-for="status in statuses" :key="status" >{{ status }}</li>
                </ul>
            </div>

        </div>


        <h1>Cursos</h1>
        <EmptyState v-if="actives?.length === 0 && coursesReady && filters.search !== ''" :type="'search'" :message="filters.search"  />
        <h2 v-else-if="filters.status === 'Todos'">Tienes <strong>{{ totalLength }} cursos</strong> en total</h2>
        <h2 v-else-if="filters.status === 'En progreso'">Tienes <strong>{{ actives.totalResults }} cursos</strong> en progreso</h2>
        <template v-if="filters.status === 'Todos' || filters.status === 'En progreso'">
            <div class="courses__pagination">
                <h3 class="courses__title">
                    Cursos que están en progreso
                    <button v-if="filters.status !== 'En progreso'" @click="filters.status = 'En progreso'" class="courses__title--more" >Ver todos <i class="material-icons-outlined">arrow_forward</i></button>
                </h3>
                <div v-if="actives?.totalPages && filters.status === 'Todos'">
                    {{ activesScrollNumber }} / {{ actives.totalPages }}
                    <div class="courses__paginationArrows">
                        <i @click="handleScrollActives(false)" class="material-icons-outlined" :class="{'arrowDisabled': activesScrollNumber === 1  }" >arrow_back</i>
                        <i @click="handleScrollActives(true)" class="material-icons-outlined" :class="{ 'arrowDisabled': activesScrollNumber === actives.totalPages }" >arrow_forward</i>
                    </div>
                </div>
            </div>
            <div class="courses" :class="{'courses--all': filters.status === 'En progreso'}" ref="activesContent" v-if="coursesReady">
                <InformationRectangle 
                    icon="class" 
                    title="No tienes cursos en progreso" 
                    message="Cuando inicies un curso, lo encontrarás aquí" 
                    background="#ffddd7" 
                    color="#F57055"
                    v-if="actives.totalResults === 0" 
                />
                <template v-for="(course,index) in actives.data" :key="index">
                    <CourseCard :loader="coursesReady" :course="course" :isFinished="false" />
                </template>
                <CourseCard v-if="moreCoursesLoading" :loader="false" />
            </div>
            <div class="courses" v-else>
                <CourseCard :loader="coursesReady" />
                <CourseCard :loader="coursesReady" />
                <CourseCard :loader="coursesReady" />
            </div>
        </template>
        <template v-if="filters.status === 'Todos' || filters.status === 'Finalizados'" >
            <h3>Cursos que ya finalizaron</h3>
            <InformationRectangle 
                icon="error"
                title="Cursos finalizados" 
                message="Recuerda que podrás seguir viendo todos los contenidos aunque ya no será posible participar." 
                background="#DEF1F1"
                color="#0A5078"
            />
            <div class="courses--finished" v-if="coursesReady">
                <template v-for="(course, index) in finished.data" :key="index">
                    <CourseCard :loader="coursesReady" :course="course" :isFinished="true"/>
                </template>
                <CourseCard v-if="moreCoursesLoading" :loader="false " />
            </div>
            <div class="courses" v-else>
                <CourseCard :loader="coursesReady" />
                <CourseCard :loader="coursesReady" />
                <CourseCard :loader="coursesReady" />
            </div>
        </template>
    </div>
    
</template>

<script>
import { useStore } from 'vuex';
import { onMounted, onUnmounted, ref  } from 'vue';
import { useRouter } from 'vue-router';
import { inject } from "@vue/runtime-core";
import CourseCard from '../components/CourseCard.vue';
import EmptyState from '../components/EmptyState.vue';
import { computed } from '@vue/reactivity';
import InformationRectangle from '../components/InformationRectangle.vue';
import Loader from '../components/Loader.vue'

export default {
    components: {
    CourseCard,
    EmptyState,
    InformationRectangle,
    Loader
},
    setup() {
        const store = useStore();
        const router = useRouter();
        const user = computed(() => store.getters.manageUser_user);
        const actives = ref();
        const formatDate = inject('formatDate');
        const coursesReady = ref(false);
        const optionsLoaded = ref(false)
        const inputSearch = ref('')
        const pageLoaded = ref(false)
        const finishedPageNumber = ref(0)
        const activesPageNumber = ref(1)
        const finished = ref()
        const totalLength = ref()
        const scrollComponent = ref(null)
        const moreCoursesLoading = ref(false)
        const activesScrollNumber = ref(1)
        const test = ref('')
        const activesContent = ref()
        const isScrolling = ref(false)
        const filters = ref({
            search: '',
            status: 'Todos',
            tutor: ''
        })  
        const statuses = ref(['Todos', 'En progreso', 'Finalizados'])
        const tutors = ref([])
        const selectedTutorName = ref('Facilitadores')
        const isDropdownOpen = ref(false); // false means the dropdown is initially closed
        const searchTutor = ref(''); // This will hold the search query


        // Assume tutors is already a ref() containing the list of tutors
        const filteredTutors = computed(() => {
            return tutors.value.filter(tutor =>
                tutor.fullName.toLowerCase().includes(searchTutor.value.toLowerCase())
            );
        });


        const cleanFilterTutors = () => {
            searchTutor.value = '';
        }


        const getTutors = async () => {
            try {
                let req = await store.dispatch('stuff_tutors_site_api')
                tutors.value = req.data
            } catch (err) {
                console.log(err)
                store.dispatch('notifications_create', {text: 'Ha ocurrido un error obteniendo los facilitadores.'})
            }
        }

        const getCourses = async () => {
            coursesReady.value = false;
            try {
                let coursesActives = await store.dispatch('courses_actives', { pageNumber: 0, rowsPerPage: 12, userId: filters.value.tutor });
                let coursesFinished = await store.dispatch('courses_finished', { pageNumber: 0, userId: filters.value.tutor})
                finishedPageNumber.value++
                finished.value = coursesFinished.data
                actives.value = coursesActives.data;
                let cardsVisibles = window.innerWidth >= 1400 ? 4 : window.innerWidth >= 1100 ? 3 : window.innerWidth >= 700 ? 2 : 1
                // actives.value.totalPages = Math.round(actives.value.data.length / cardsVisibles) || 1
                actives.value.totalPages = Math.ceil(actives.value.data.length / cardsVisibles) || 1
                actives.value.data.forEach(course => course.image !== null && course.image.replace('.png', '_thumb.png'))
                finished.value.data.forEach(course => course.image !== null && course.image.replace('.png', '_thumb.png'))
                totalLength.value = coursesActives.data.totalResults + coursesFinished.data.totalResults
            } catch (err) {
                console.log(err)
                store.dispatch('notifications_create', {text: 'Ha ocurrido un error.'})
            } finally{
                coursesReady.value = true;
            }
        }

        const getMoreCourses = async () => {
            if (filters.value.status === 'Finalizados' || filters.value.status === 'Todos') {
                if ((finished.value.totalResults - finished.value.data.length) > 0) {
                    moreCoursesLoading.value = true
                    const { data } = await store.dispatch('courses_finished', { pageNumber: finishedPageNumber.value, userId: filters.value.tutor })
                    data.data.forEach(course => course.image !== null && course.image.replace('.png', '_thumb.png'))
                    finished.value.data.push(...data.data)
                    finishedPageNumber.value++
                    moreCoursesLoading.value = false
                }
            }
            else {
                if ((actives.value.totalResults - actives.value.data.length) > 0) {
                    moreCoursesLoading.value = true
                    const { data } = await await store.dispatch('courses_actives', { pageNumber: activesPageNumber.value, rowsPerPage: 12, userId: filters.value.tutor })
                    data.data.forEach(course => course.image !== null && course.image.replace('.png', '_thumb.png'))
                    actives.value.data.push(...data.data)
                    activesPageNumber.value++
                    moreCoursesLoading.value = false
                }
            }
        }


        const handleScroll = () => {
            if (!moreCoursesLoading.value) {
                let element = scrollComponent.value
                if (element.getBoundingClientRect().bottom - 1 < window.innerHeight) {
                    if (filters.value.status === 'Todos' || filters.value.status === 'Finalizados') {
                        if((finished.value.totalResults - finished.value.data.length) > 0)  getMoreCourses()
                    }
                    else {
                        if ((actives.value.totalResults - actives.value.data.length) > 0) getMoreCourses()
                    } 
                }
            }
        }


        onMounted(async () => {
            if (!user.value?.permissions?.includes('CURSO_VER_PROPIOS')) router.replace('/login')
            pageLoaded.value = true
            getCourses()
            getTutors()
            window.addEventListener('scroll', handleScroll)
            window.addEventListener('resize', () => {
                let cardsVisibles = window.innerWidth >= 1400 ? 4 : window.innerWidth >= 1100 ? 3 : window.innerWidth >= 700 ? 2 : 1
                actives.value.totalPages = Math.round(actives.value.data.length / cardsVisibles) || 1
            })
        })

        onUnmounted(() => {
            window.removeEventListener('scroll', handleScroll)
        })
        

        function goToCourse(id){
            router.push(`/course/${id}`)
        }
        const scrollTo = (element, pixels, duration) => {
            const startingX = element.scrollLeft;
            const targetX = startingX + pixels;
            const diff = targetX - startingX;
            const easing = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);
            let start;

            if (!diff) return;

            function step(timestamp) {
                if (!start) start = timestamp;
                const time = timestamp - start;
                let percent = Math.min(time / duration, 1);
                percent = easing(percent);

                element.scrollLeft = startingX + diff * percent;

                if (time < duration) {
                    window.requestAnimationFrame(step);
                }
            }
            window.requestAnimationFrame(step);
            const prom = new Promise((resolve) => {
                setTimeout(() => {
                    resolve('Its Ok')
                }, duration)
            })
            return prom
        }

        const hiddenItems = (id) => {
            document.getElementById(id).checked = false
        }
        
        const addSearchFilter = () => {
            filters.value.search = inputSearch.value.trim(); 
            getCourses()
        }

        const handleScrollActives = async (forward) => {
            let scrollPx = window.innerWidth >= 1400 ? 1342 : window.innerWidth >= 1100 ? 1008 : window.innerWidth >= 700 ? 672 : 336
            if (forward) {
                if (activesScrollNumber.value === actives.value.totalPages || isScrolling.value) return
                isScrolling.value = true
                await scrollTo(activesContent.value, scrollPx, 450)
                activesScrollNumber.value++
                isScrolling.value = false
            } else {
                if (activesScrollNumber.value <= 1 || isScrolling.value) return
                isScrolling.value = true
                await scrollTo(activesContent.value, -scrollPx, 450)
                activesScrollNumber.value--
                isScrolling.value = false
            }
        }

        return{
            actives,
            goToCourse,
            formatDate,
            coursesReady,
            filters,
            addSearchFilter,
            optionsLoaded,
            getCourses,
            getTutors,
            selectedTutorName,
            inputSearch,
            user,
            pageLoaded,
            statuses,
            tutors,
            hiddenItems,
            finished,
            totalLength,
            scrollComponent,
            moreCoursesLoading,
            test,
            activesScrollNumber,
            handleScrollActives,
            activesContent,
            isDropdownOpen,
            searchTutor,
            filteredTutors,
            cleanFilterTutors
        }
    },
}
</script>
<style lang="scss" scoped>
@import '@/styles/main.scss';
@import '~vue-skeletor/dist/vue-skeletor.css';
h2 {
    font-size: 20px;
    font-weight: 400;
    color: $black;
    margin: 22px 0;
    @media screen and (max-width: $bpSmall){
        font-size: 15px;
        padding-left: 12px;
    }
}

h1{
    font-size: 24px;
    font-weight: 700;
    color: #212121;
    margin: 20px 0;
}

h3{
    font-size: 20px;
    font-weight: 600;
    margin: 20px 0;
}


.filters{
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.dropdown{

    &__search {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;

        #filter-search{
            display: inline-block;
            background-color: inherit;
            border-radius: 25px;
            border: 1px solid #212121;
            cursor: pointer;
            font-style: normal;
            font-weight: 500;
            font-size: 13px;
            line-height: 16px;
            color: #212121;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            padding: 6px 12px;
            display: flex;
            justify-content: space-around;
            align-content: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
            height: 32px;
            padding-right: 36px;
        }
        .material-icons {
            position: absolute;
            font-size: 18px;
            right: 0;
            padding: 13px;
        }
    }

    &__items{
        background: #f6f6f6 !important;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 25px;
        border: none;
    }

    &__face {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        justify-content: space-between;
    }


    &--tutors {
        margin-right: 4px;
        width: 280px;

        &__items {
            padding: 0;
            padding-right: 20px;
            
            &__cont {
                max-height: 122px;
                overflow-y: auto;
                gap: 10px;
                display: flex;
                flex-direction: column;
                padding-top: 20px;
                padding-left: 20px;
                padding-bottom: 20px;
                padding-right: 0;

                &::-webkit-scrollbar-track {
                border-radius: 100px;
                background-color: rgba(0,0,0,0);
                margin: 20px;
                }
                &::-webkit-scrollbar {
                    width: 5px;
                    height: 10px;
                    background-color: transparent;
                    margin: 4px 0;
                }
                &::-webkit-scrollbar-thumb {
                    border-radius: 100px;
                    background: #D9D9D9;
                    position: absolute;
                }
            }

        }
    }
}

.filter-nav{
    margin: 16px 6px;
    height: 32px;
    display: flex;
    justify-content: space-between;
    .filter-order{
        display: flex;
        gap: 16px;
        button{
            height: 100%;
            width: 150px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            border: 1px solid $black;
            border-radius: 100px;
            padding: 6 12px;
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: $black;
        }
    }
}

.main-container{
    padding: 30px 0;
    width: 1342px;
    margin: 0 auto;
    @media screen and (max-width: 1400px){
        width: 1000px;
    }
    @media screen and (max-width: 1100px){
        width: 670px;
    }
    @media screen and (max-width: 700px){
        width: 88%;
    }
    .courses{
        width: 100%;
        padding: 12px 6px;
        display: flex;
        gap: 16px;
        overflow: hidden;
        justify-content: flex-start;
        @media screen and (max-width: 700px){
            width: 330px;
            margin: 0 auto;
        }
        &::-webkit-scrollbar-track {
            border-radius: 100px;
            background-color: rgba(0,0,0,.1);
        }
        &::-webkit-scrollbar {
            width: 10px;
            height: 10px;
            background-color: transparent;
            margin: 4px 0;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 100px;
            background: map-get($dark, 400);
            position: absolute;
        }
        &--finished{
            @extend .courses;
            flex-wrap: wrap;
            overflow: visible;
        }
    }
}

.course-card{
    min-width: 317.5px;
    height: 386px;
    padding: 16px;
    padding-bottom: 24px;
    @include flex-column;
    gap: 4px;
    border-radius: 10px;
    background-color: #fff;
    color: $black;
    cursor: pointer;
    >* { 
        width: 100%; 
    }
    
    &__img{
        height: 35%;
        text-align: center;
        border-radius: 4px;
    }
    &__name{
        font-weight: 700;
        font-size: 18px;
        
    }
    &__end-date{
        font-weight: 600;
        font-size: 12px;
    }

    &__description {
        font-size: 13px;
        margin: 12px 0;
    }

    &__quantities{
        display: flex;
        justify-content: space-between;

        &__info {
            display: flex;
            flex-direction: column;
            font-weight: 400;
            font-size: 14px;
        }

        &__detail {
            button {
                display: flex;
                align-items: center;
                color: #009696;
                gap: 4px;
                border: 1px solid;
                padding: 8px 16px;
                border-radius: 44px;
            }
        }
    }
}

.tags__container{
    margin: 16px 0;
    .tags__filter{
        display: inline-flex;
        align-items: center;
        margin: 5px 6px;
        font-weight: 500;
        font-size: 13px;
        line-height: 16px;
        color: $black;
        border-radius: 999px;
        background-color: rgba($color: $black, $alpha: .1);
        padding: 8px 16px;
        .material-icons{
            font-size: 13px;
            margin-left: 5px;
            cursor: pointer;
        }
    }
}

@media (max-width: $bpBig){
    .filter-nav{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        .search input{
            height: 32px;
        }
        .filter-order{
            justify-content: space-around;
        }
    }
}
.arrowDisabled{
    opacity: .4;
    cursor: default !important;
}

.courses{
    &__pagination{
        display: flex;
        align-items: center;
        justify-content: space-between;
        >div{
            display: flex;
            align-items: center;
            gap: 12px;
            @media screen and (max-width: 700px){
                flex-direction: column;
                align-items: center;
            }
        }
        .material-icons-outlined{
            cursor: pointer;
            width: 24px;
        }
    }
    &__title{
        display: flex;
        align-items: center;
        gap: 12px;
        &--more{
            font-size: 16px;
            display: flex;
            align-items: center;
            color: $green;
            .material-icons-outlined{
                font-size: 18px;
            }
        }
        @media screen and (max-width: 700px){
            flex-direction: column;
            align-items: flex-start;
        }
    }
    &--all{
        flex-wrap: wrap;
    }
    &__paginationArrows{
        display: flex;
        align-items: center;
        gap: 12px;
    }


}

</style>